/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import { changeCatSplit } from '../../../redux/ducks/collections';
import { collectionsByType } from '../../../redux/selectors/collections';
import { collectionsGroupType, catSplitAttrsType } from '../../common/types';
import SliderGallery from '../../SliderGallery';
import SliderGalleryItem from '../../../models/SliderGalleryItem';
import pageWrapper from '../../containers/MainPage';
import slug from '../../../slugger';
import { NotFound } from '../../NotFound';
import Breadcrumbs from '../../common/Breadcrumbs';
import itemTypePluralize from '../../common/itemTypePluralrize';
import AddItemButton from './AddItemButton';
import SplitAttributeSelect from './SplitAttributeSelect';
import CollectionFilterSwitcher from './CollectionFilterSwitcher';

class CategoryPage extends React.Component {
  render() {
    const { collections, catSplitAttributes, onChangeSplitAttribute } = this.props;
    const {
      match: {
        params: { category },
      },
    } = this.props;
    const collectionsCat = collections[category];
    const catSplitAttribute = !catSplitAttributes[category] ? catSplitAttributes.OTHER : catSplitAttributes[category];

    if (!collectionsCat) {
      return <NotFound />;
    }

    return (
      <React.Fragment>
        <Breadcrumbs
          segments={[
            { label: 'Collections', linkTo: '/collections' },
            { label: itemTypePluralize(category) },
          ]}
        />

        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div className="field is-grouped">
                <CollectionFilterSwitcher />

                <SplitAttributeSelect
                  currentSplitAttr={catSplitAttribute}
                  category={category}
                  onChangeAttr={onChangeSplitAttribute}
                />
              </div>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <AddItemButton />
            </div>
          </div>
        </div>

        {_.map(collectionsCat, (coll, subcatKey) => (
          <div key={subcatKey}>
            <h3 className="title is-4" style={{ marginBottom: 0 }}>
              <Link to={`/collections/${category}/${catSplitAttribute}/${slug(subcatKey)}`}>
                {subcatKey || '(Unknown)'}
              </Link>
            </h3>

            <SliderGallery
              items={SliderGalleryItem.ItemsFromSubcategory(
                coll,
                category,
                catSplitAttribute,
                subcatKey
              )}
              splitAttr={catSplitAttribute}
            />
          </div>
        ))}
      </React.Fragment>
    );
  }
}

CategoryPage.propTypes = {
  collections: collectionsGroupType,
  match: PropTypes.shape({
    shape: PropTypes.shape({
      category: PropTypes.string,
    }),
  }).isRequired,
  catSplitAttributes: catSplitAttrsType.isRequired,
  onChangeSplitAttribute: PropTypes.func.isRequired,
};

CategoryPage.defaultProps = {
  collections: [],
};

function mapStateToProps(state) {
  const {
    collections: { catSplitAttributes },
  } = state;

  return {
    collections: collectionsByType(state),
    catSplitAttributes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeSplitAttribute: (category, newAttr) => {
      dispatch(changeCatSplit(category, newAttr));
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(CategoryPage),
  'My Collection'
);



// WEBPACK FOOTER //
// ./src/components/pages/collections/CategoryPage.jsx